var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "additional" },
    [
      _c("div", { staticClass: "head" }, [
        _c("ul", [
          _c(
            "li",
            [
              _c("h5", [_vm._v("上下线")]),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择" },
                  model: {
                    value: _vm.form.line,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "line", $$v)
                    },
                    expression: "form.line",
                  },
                },
                _vm._l(_vm.lines, function (item) {
                  return _c("el-option", {
                    key: item.line,
                    attrs: { label: item.label, value: item.line },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            [
              _c("h5", [_vm._v("产品型号")]),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: { placeholder: "请选择" },
                  model: {
                    value: _vm.form.productType,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "productType", $$v)
                    },
                    expression: "form.productType",
                  },
                },
                _vm._l(_vm.type, function (item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.valueCn, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.search } },
                [_vm._v("查询")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.empty } },
                [_vm._v("清空")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              directives: [
                {
                  name: "permit",
                  rawName: "v-permit",
                  value: "/cms/additional/item/add",
                  expression: "'/cms/additional/item/add'",
                },
              ],
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.add } },
                [_vm._v("新增")]
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticStyle: { width: "100%", "margin-top": "30px" },
          attrs: { data: _vm.tableData, border: "" },
        },
        [
          _c("el-table-column", {
            attrs: { align: "center", label: "序号" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm.isShow == scope.row.id
                      ? _c("el-input", {
                          directives: [{ name: "focus", rawName: "v-focus" }],
                          attrs: {
                            type: "text",
                            autofocus: true,
                            maxlength: "9",
                          },
                          on: {
                            blur: function ($event) {
                              return _vm.bindSeq(scope.row)
                            },
                          },
                          model: {
                            value: scope.row.seq,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "seq", $$v)
                            },
                            expression: "scope.row.seq",
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isShow != scope.row.id,
                            expression: "isShow  != scope.row.id",
                          },
                        ],
                        on: {
                          click: function ($event) {
                            return _vm.changeSeq(scope.row)
                          },
                        },
                      },
                      [_vm._v(_vm._s(scope.row.seq))]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "产品型号",
              "show-overflow-tooltip": "",
              prop: "type",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "标题CN",
              "show-overflow-tooltip": "",
              prop: "titleCn",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "标题EN",
              "show-overflow-tooltip": "",
              prop: "titleEn",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "标题JA",
              "show-overflow-tooltip": "",
              prop: "titleJa",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "上线/下线",
              prop: "line",
              formatter: _vm.lineFormatter,
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { align: "center", label: "操作人", prop: "updateUser" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "操作时间",
              "show-overflow-tooltip": "",
              prop: "updateTime",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { align: "center", label: "操作" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      { staticClass: "function-icon" },
                      [
                        _c(
                          "el-tooltip",
                          {
                            directives: [
                              {
                                name: "permit",
                                rawName: "v-permit",
                                value: "/cms/additional/item/update",
                                expression: "'/cms/additional/item/update'",
                              },
                            ],
                            staticClass: "item",
                            attrs: {
                              effect: "dark",
                              content: "修改",
                              placement: "bottom",
                            },
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: require("../../assets/iconfont/amend.png"),
                                alt: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.change(scope.row)
                                },
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-tooltip",
                          {
                            directives: [
                              {
                                name: "permit",
                                rawName: "v-permit",
                                value: "/cms/additional/item/delete",
                                expression: "'/cms/additional/item/delete'",
                              },
                            ],
                            staticClass: "item",
                            attrs: {
                              effect: "dark",
                              content: "删除",
                              placement: "bottom",
                            },
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: require("../../assets/iconfont/delete.png"),
                                alt: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.dele(scope.row)
                                },
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-tooltip",
                          {
                            directives: [
                              {
                                name: "permit",
                                rawName: "v-permit",
                                value: "/cms/additional/item/online",
                                expression: "'/cms/additional/item/online'",
                              },
                            ],
                            staticClass: "item",
                            attrs: {
                              effect: "dark",
                              content: "上线",
                              placement: "bottom",
                            },
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: require("../../assets/iconfont/online.png"),
                                alt: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.online(scope.row)
                                },
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-tooltip",
                          {
                            directives: [
                              {
                                name: "permit",
                                rawName: "v-permit",
                                value: "/cms/additional/item/unline",
                                expression: "'/cms/additional/item/unline'",
                              },
                            ],
                            staticClass: "item",
                            attrs: {
                              effect: "dark",
                              content: "下线",
                              placement: "bottom",
                            },
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: require("../../assets/iconfont/offline.png"),
                                alt: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.offline(scope.row)
                                },
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-tooltip",
                          {
                            directives: [
                              {
                                name: "permit",
                                rawName: "v-permit",
                                value: "/cms/additional/item/preview",
                                expression: "'/cms/additional/item/preview'",
                              },
                            ],
                            staticClass: "item",
                            attrs: {
                              effect: "dark",
                              content: "预览",
                              placement: "bottom",
                            },
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: require("../../assets/iconfont/view.png"),
                                alt: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.preview(scope.row)
                                },
                              },
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "page" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              layout: "total, prev, pager, next",
              "page-size": 10,
              total: _vm.total,
              "current-page": _vm.currentPage,
            },
            on: { "current-change": _vm.changepage },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.titletype,
            visible: _vm.dialogFormVisible,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
            close: function ($event) {
              return _vm.addClose("addform")
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "addform",
              attrs: {
                model: _vm.addform,
                rules: _vm.rules,
                "status-icon": true,
                "show-message": false,
                "hide-required-asterisk": "",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "序号",
                    "label-width": _vm.formLabelWidth,
                    prop: "seq",
                  },
                },
                [
                  _c("el-input", {
                    attrs: { autocomplete: "off", type: "text" },
                    model: {
                      value: _vm.addform.seq,
                      callback: function ($$v) {
                        _vm.$set(_vm.addform, "seq", $$v)
                      },
                      expression: "addform.seq",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "产品型号",
                    "label-width": _vm.formLabelWidth,
                    prop: "type",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "请选择" },
                      model: {
                        value: _vm.addform.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.addform, "type", $$v)
                        },
                        expression: "addform.type",
                      },
                    },
                    _vm._l(_vm.type, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.valueCn, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "标题中文",
                    "label-width": _vm.formLabelWidth,
                    prop: "titleCn",
                  },
                },
                [
                  _c("el-input", {
                    attrs: { autocomplete: "off", maxlength: "50" },
                    model: {
                      value: _vm.addform.titleCn,
                      callback: function ($$v) {
                        _vm.$set(_vm.addform, "titleCn", $$v)
                      },
                      expression: "addform.titleCn",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "标题英文",
                    "label-width": _vm.formLabelWidth,
                    prop: "titleEn",
                  },
                },
                [
                  _c("el-input", {
                    attrs: { autocomplete: "off", maxlength: "50" },
                    model: {
                      value: _vm.addform.titleEn,
                      callback: function ($$v) {
                        _vm.$set(_vm.addform, "titleEn", $$v)
                      },
                      expression: "addform.titleEn",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "标题日文",
                    "label-width": _vm.formLabelWidth,
                    prop: "titleJa",
                  },
                },
                [
                  _c("el-input", {
                    attrs: { autocomplete: "off", maxlength: "50" },
                    model: {
                      value: _vm.addform.titleJa,
                      callback: function ($$v) {
                        _vm.$set(_vm.addform, "titleJa", $$v)
                      },
                      expression: "addform.titleJa",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.addClose("addform")
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", disabled: _vm.isDisable },
                  on: {
                    click: function ($event) {
                      return _vm.sure("addform")
                    },
                  },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }